import { isMultiplaySessionEnabled } from './isMultiplaySession';

/** Base user id without multiplayer play-count suffix. */
export function stripPlayCountFromUserId(userId) {
  const s = String(userId ?? '').trim();
  const lastUnderscore = s.lastIndexOf('_');
  if (lastUnderscore <= 0) return s;
  const suffix = s.slice(lastUnderscore + 1);
  if (/^\d+$/.test(suffix)) return s.slice(0, lastUnderscore);
  return s;
}

export function userPlayedCountFrom(rec) {
  if (!rec || typeof rec !== 'object') return null;
  const candidates = [
    rec.userPlayedCount,
    rec.user_played_count,
    rec.playedCount,
    rec.session?.userPlayedCount,
    rec.session?.user_played_count,
  ];
  for (const v of candidates) {
    const n = Number(v);
    if (Number.isFinite(n) && n >= 0) return Math.trunc(n);
  }
  return null;
}

export function baseUserIdFrom(user) {
  const raw =
    user?.baseUserId ??
    user?.userId ??
    user?.userid ??
    user?.id ??
    '';
  return stripPlayCountFromUserId(raw);
}

/** DB stages.userid — base id, or base_playCount when multiplayer (e.g. dhdeykbd_1). */
export function buildDbUserId(baseUserId, userPlayedCount, isMultiplay) {
  const base = stripPlayCountFromUserId(baseUserId);
  if (!base) return '';
  if (!isMultiplay) return base;
  const count =
    userPlayedCount != null ? Number(userPlayedCount) : null;
  if (!Number.isFinite(count) || count < 0) return base;
  return `${base}_${Math.trunc(count)}`;
}

export function getDbUserId(user) {
  if (!user || typeof user !== 'object') return '';
  const explicit = user.dbUserId ?? user.db_user_id;
  if (explicit != null && String(explicit).trim() !== '') {
    return String(explicit).trim();
  }
  const base = baseUserIdFrom(user);
  const count = userPlayedCountFrom(user);
  return buildDbUserId(base, count, isMultiplaySessionEnabled(user));
}

/** External game-server report APIs — always the real user id without _playCount. */
export function getExternalUserId(user) {
  return baseUserIdFrom(user);
}

export function externalUserIdFrom(userIdOrUser) {
  if (userIdOrUser != null && typeof userIdOrUser === 'object') {
    return getExternalUserId(userIdOrUser);
  }
  return stripPlayCountFromUserId(userIdOrUser);
}
